module.exports = __webpack_public_path__ + "static/media/enterprise.f029fbdc.jpg";